export interface DurationLabels {
  day: string
  hour: string
  minute: string
}

export interface SecondsDurationLabels extends DurationLabels {
  second: string
}

export const SECONDS_IN_MINUTE = 60
const MINUTES_IN_HOUR = 60
const MINUTES_IN_DAY = 24 * MINUTES_IN_HOUR

type DurationPart = [value: number, label: string]

const getDayHourMinuteParts = (
  totalMinutes: number,
  labels: DurationLabels
): DurationPart[] => [
  [Math.floor(totalMinutes / MINUTES_IN_DAY), labels.day],
  [Math.floor((totalMinutes % MINUTES_IN_DAY) / MINUTES_IN_HOUR), labels.hour],
  [totalMinutes % MINUTES_IN_HOUR, labels.minute],
]

// Zero parts are skipped
const joinDurationParts = (parts: DurationPart[], language: string) => {
  const formatter = new Intl.NumberFormat(language)

  return parts
    .filter(([value]) => value > 0)
    .map(([value, label]) => `${formatter.format(value)} ${label}`)
    .join(' ')
}

// e.g. 1501 -> "1 d 1 h 1 min", 0 -> "0 min"
export const formatMinutesDuration = (
  totalMinutes: number,
  language: string,
  labels: DurationLabels
): string =>
  totalMinutes === 0
    ? `${new Intl.NumberFormat(language).format(0)} ${labels.minute}`
    : joinDurationParts(getDayHourMinuteParts(totalMinutes, labels), language)

// e.g. 90061 -> "1 d 1 h 1 min 1 s"
export const formatSecondsDuration = (
  totalSeconds: number,
  language: string,
  labels: SecondsDurationLabels
): string =>
  joinDurationParts(
    [
      ...getDayHourMinuteParts(
        Math.floor(totalSeconds / SECONDS_IN_MINUTE),
        labels
      ),
      [totalSeconds % SECONDS_IN_MINUTE, labels.second],
    ],
    language
  )
